
<template>
	<v-container grid-list-md fluid="fluid">
		<v-form v-model="valid" ref="settingsForm" lazy-validation>
			<v-layout wrap px-0 style="max-width: 1000px">
				<v-flex xs12 sm12 md12>
					<h2>Appinstellingen</h2>
					<v-switch label="Animaties" v-model="animation"></v-switch>
					<!-- <v-switch label="Meldingen" v-model="notifications"></v-switch> -->
				</v-flex>
				<v-flex xs12 sm12 md12>
					<h2 class="mb-2">Bedrijfsgegevens</h2>
					<small>Logo</small>
				</v-flex>
				<v-flex xs12 sm12 md12>
					<img
						:src="basePath + companyData.logo"
						class="d-block"
						v-if="!image"
						style="max-width: 200px"
					/>
					<img
						v-bind:src="image"
						v-if="image"
						class="d-block"
						style="max-width: 200px"
					/>
				</v-flex>
				<v-flex xs12 sm12 md12>
					<input type="file" @change="setImage" accept="image/*" class="mb-2" />
				</v-flex>
				<v-flex xs12 sm12 md12>
					<v-text-field
						name="description"
						v-model="companyData.name"
						required
						:rules="basicRules"
						label="Bedrijfsnaam (kort)"
					></v-text-field>
				</v-flex>
				<v-flex xs12 sm12 md12>
					<v-textarea
						name="description"
						v-model="companyData.description"
						required
						:rules="basicRules"
						label="Bedrijfsnaam"
					></v-textarea>
				</v-flex>
				<v-flex xs8 sm8 md10>
					<v-text-field
						label="Straatnaam"
						type="text"
						v-model="companyData.street"
						required
						:rules="basicRules"
					></v-text-field>
				</v-flex>
				<v-flex xs4 sm4 md2>
					<v-text-field
						label="Huisnummer"
						type="text"
						v-model="companyData.houseno"
						required
						:rules="basicRules"
					></v-text-field>
				</v-flex>
				<v-flex xs12 sm6 md6>
					<v-text-field
						label="Plaats"
						type="text"
						v-model="companyData.city"
						required
						:rules="basicRules"
					></v-text-field>
				</v-flex>

				<v-flex xs12 sm6 md6>
					<v-text-field
						label="Postcode"
						type="text"
						v-model="companyData.zip"
						required
						:rules="basicRules"
					></v-text-field>
				</v-flex>

				<v-flex xs12 sm12 md12>
					<v-text-field
						label="Land"
						type="text"
						v-model="companyData.country"
						required
						:rules="basicRules"
					></v-text-field>
				</v-flex>
				<v-flex xs12 sm12 md12>
					<v-text-field
						label="Telefoonummer"
						type="text"
						v-model="companyData.phoneno"
						required
						:rules="basicRules"
					></v-text-field>
				</v-flex>
				<v-flex xs12 sm12 md12>
					<v-text-field
						label="E-mailadres"
						type="text"
						v-model="companyData.email"
						required
						:rules="emailRules"
					></v-text-field>
				</v-flex>
				<v-flex xs12 sm12 md12>
					<v-text-field
						label="Website"
						type="text"
						v-model="companyData.website"
					></v-text-field>
				</v-flex>
				<v-flex xs12 sm12 md12>
					<v-text-field
						label="KvK"
						type="text"
						v-model="companyData.kvk"
						required
						:rules="basicRules"
					></v-text-field>
				</v-flex>
				<v-flex xs12 sm12 md12>
					<v-text-field
						label="Btwnummer"
						type="text"
						v-model="companyData.vatno"
						required
						:rules="basicRules"
					></v-text-field>
				</v-flex>

				<v-flex xs12 sm12 md12>
					<v-text-field
						label="Bankreknummer"
						type="text"
						v-model="companyData.bankno"
						required=""
						:rules="basicRules"
					></v-text-field>
				</v-flex>

				<v-btn color="primary" @click="saveSettings()">Opslaan</v-btn>
			</v-layout>
		</v-form>
		<small>Versie: {{ appVersion }}</small>
	</v-container>
</template>
<script>
import * as utils from '@/utils/utils';
import { version } from '../../package.json';

export default {
	name: 'Settings',
	components: {},
	data() {
		return {
			utils: utils,
			defaultAnimation: 'scale-transition',
			settings: {
				animation: ''
			},
			image: '',
			companyData: {},
			valid: false,
			notifications: false,
			appVersion: '',
			basicRules: [v => !!v || 'Verplicht veld'],
			emailRules: [
				v => !!v || 'E-mailadres is verplicht',
				v => this.utils.checkEmailAddress(v) || 'Ongeldig email-adres'
			]
		};
	},
	created() {
		this.appVersion = version;
		this.getSettings();
	},
	computed: {
		animation: {
			get: function() {
				return this.settings.animation !== 'none';
			},
			set: function(value) {
				this.settings.animation = value ? this.defaultAnimation : 'none';
			}
		},
		basePath() {
			return basePath.replace('index.php/', '');
		}
	},
	watch: {
		'settings.animation'() {
			this.utils.saveSettings(this.settings);
		},
		notifications(value) {
			if (value) {
				OneSignal.registerForPushNotifications({
					modalPrompt: true
				});
			}
		}
	},
	methods: {
		setImage(e) {
			var self = this;
			var files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;

			var file = files[0];
			var image = new Image();
			var reader = new FileReader();
			var vm = this;

			reader.onload = e => {
				self.image = e.target.result;
			};

			reader.readAsDataURL(file);
		},
		getSettings() {
			const self = this;
			utils.getData(basePath + 'api/dealers/getSettings/').then(function(json) {
				if (json.data) {
					self.companyData = json.data;
				}
			});
		},
		saveSettings() {
			if (this.image) {
				this.companyData.image = this.image;
			}

			if (this.$refs.settingsForm.validate()) {
				utils
					.setData(basePath + 'api/dealers/updateSettings/', this.companyData)
					.then(function(json) {
						window.emitter.$emit('showToastMessage', {
							msg: 'Instellingen opgeslagen'
						});
					});
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Settings.vue